import EFVideoModal from '@/components/UI/EFVideoModal';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

let sceneEnterA: any = null,
    sceneLeaveA: any = null;
export default function A() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [visible, setVisible] = useState(false);
    const [enter, setEnter] = useState(false);
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);

    const handlePlay = () => {
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('secA_title'),
            position: 'Product Detail_1',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);

            const resizeAni = () => {
                if (sceneEnterA) {
                    AniContainer.removeScene(sceneEnterA);
                    sceneEnterA = null;
                }
                if (sceneLeaveA) {
                    AniContainer.removeScene(sceneLeaveA);
                    sceneLeaveA = null;
                }

                sceneEnterA = AniContainer.create({
                    triggerElement: '.dpu-detail-A',
                    triggerHook: 1,
                    offset: startH,
                    duration: '70%',
                    onEnter: () => setEnter(true),
                });

                sceneLeaveA = AniContainer.create({
                    triggerElement: '.dpu-detail-A',
                    triggerHook: 1,
                    offset: 0,
                    duration: '200%',
                    onLeave: () => setEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnterA) {
                    AniContainer.removeScene(sceneEnterA);
                    sceneEnterA = null;
                }
                if (sceneLeaveA) {
                    AniContainer.removeScene(sceneLeaveA);
                    sceneLeaveA = null;
                }
                //window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-A dpu-detail-section ${css['dpu-detail-A']}`}>
            <div className={`img-box`}>
                <EFPicture
                    src={
                        locale === 'au'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1753171280327/kv.jpg'
                            : isEU
                            ? 'https://websiteoss.ecoflow.com/upload/image/1751184950899/pc_KV.png'
                            : locale === 'ca'
                            ? '/responsive/picture/delta-pro-ultra/launch/1.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1747894655780/KV-PC.jpg'
                    }
                    srcPad={
                        locale === 'au'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1753171280115/kv-m.jpg'
                            : isEU
                            ? 'https://websiteoss.ecoflow.com/upload/image/1751184978917/m_KV.png'
                            : locale === 'ca'
                            ? '/responsive/picture/delta-pro-ultra/launch/1_768.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1747894655587/Frame%201612707576.jpg'
                    }
                    srcMobile={
                        locale === 'au'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1753171280115/kv-m.jpg'
                            : isEU
                            ? 'https://websiteoss.ecoflow.com/upload/image/1751184978917/m_KV.png'
                            : locale === 'ca'
                            ? '/responsive/picture/delta-pro-ultra/launch/1_768.jpg'
                            : 'https://websiteoss.ecoflow.com/upload/image/1747894655587/Frame%201612707576.jpg'
                    }
                    alt={t('secA_title')}
                />
            </div>
            <div className={`info-box  ${enter ? 'enter' : ''}`}>
                <h3 className="subtitle">{t('secA_subtitle')}</h3>
                <h1 className="title">{t('secA_title')}</h1>
                {t('secA_watch') && (
                    <>
                        <button className="video" onClick={handlePlay}>
                            <span className="video-text">{t('secA_watch')}</span>
                            <svg className="video-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.5 0.5C4.08172 0.5 0.5 4.08172 0.5 8.5C0.5 12.9183 4.08172 16.5 8.5 16.5C12.9183 16.5 16.5 12.9183 16.5 8.5C16.5 4.08172 12.9183 0.5 8.5 0.5ZM7.53418 11.5065L11.2507 8.82435C11.4719 8.6647 11.4719 8.3353 11.2507 8.17565L7.53418 5.49351C7.26963 5.30259 6.9001 5.49162 6.9001 5.81786L6.9001 11.1821C6.9001 11.5084 7.26963 11.6974 7.53418 11.5065Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </>
                )}
            </div>
            <EFVideoModal
                visible={visible}
                source={
                    locale === 'au'
                        ? 'https://www.youtube.com/embed/c-H1-uwV9fw'
                        : locale === 'jp'
                        ? 'https://www.youtube.com/embed/h3gV9Xy3hxU?si=Z4GWGGsVszDLkDRY'
                        : 'https://www.youtube.com/embed/zsonj2HPQdM?si=2GSK67QBoFc7Azgk'
                }
                onClose={() => setVisible(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </section>
    );
}
